const Footer = () => {
    return (

        <div className="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="row g-5">
                    <div className="col-lg-3 col-md-6">
                        <h5 className="text-white mb-4">Address</h5>
                        <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>Toronto, CA</p>
                        <p className="mb-2"><i className="fa fa-phone-alt me-3"></i>+1 416 356 9921</p>
                        <p className="mb-2"><i className="fa fa-envelope me-3"></i>fdtacm@gmail.com</p>
                        <div className="d-flex pt-2">
                            {/*<a className="btn btn-square btn-outline-light btn-social" href=""><i*/}
                            {/*    className="fab fa-twitter"></i></a>*/}
                            {/*<a className="btn btn-square btn-outline-light btn-social" href=""><i*/}
                            {/*    className="fab fa-facebook-f"></i></a>*/}
                            {/*<a className="btn btn-square btn-outline-light btn-social" href=""><i*/}
                            {/*    className="fab fa-youtube"></i></a>*/}
                            <a className="btn btn-square btn-outline-light btn-social" href="https://www.linkedin.com/in/alex-oudovikine-a98a94bb/"><i
                                className="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h5 className="text-white mb-4">Quick Links</h5>
                        <a className="btn btn-link" href="about">Contact Us</a>
                        <a className="btn btn-link" href="service">Our Services</a>
                        <a className="btn btn-link" href="about">Terms & Condition</a>
                        <a className="btn btn-link" href="about">Support</a>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h5 className="text-white mb-4">Application Gallery</h5>
                        <div className="row g-2">
                            {/*<div className="col-4">*/}
                            {/*    <img className="img-fluid rounded" src="img/gallery-1.jpg" alt=""></img>*/}
                            {/*</div>*/}
                            <div className="col-4">
                                <img className="img-fluid rounded" src="img/stress.png" alt=""></img>
                            </div>
                            <div className="col-4">
                                <img className="img-fluid rounded" src="img/accuracy.png" alt=""></img>
                            </div>
                            <div className="col-4">
                                <img className="img-fluid rounded" src="img/struct_fatigue.png" alt=""></img>
                            </div>
                            {/*<div className="col-4">*/}
                            {/*    <img className="img-fluid rounded" src="img/gallery-5.jpg" alt=""></img>*/}
                            {/*</div>*/}
                            {/*<div className="col-4">*/}
                            {/*    <img className="img-fluid rounded" src="img/gallery-6.jpg" alt=""></img>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h5 className="text-white mb-4">Newsletter</h5>
                        <p>Subscribe to our newsletter, to be up to date with our R&D.</p>
                        <div className="position-relative mx-auto">
                            <input className="form-control border-0 w-100 py-3 ps-4 pe-5" type="text"
                                   placeholder="Your email"></input>
                            <button type="button"
                                    className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">SignUp
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="copyright">
                    <div className="row">
                        <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                            &copy; <a href="#">STEDAX</a>, All Right Reserved.
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            {/*<!-- This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support. */}
                            Designed By <a href="https://htmlcodex.com">HTML Codex</a>
                            <br></br>Distributed By: <a href="https://themewagon.com" target="_blank">ThemeWagon</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Footer;